
import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { setBookingStep, setCart, setDataByStep } from '../../Actions';
import HorizontalList from '../Molecules/HorizontalList';
import TabsView from '../Molecules/TabsView';
import GridOptions from '../Molecules/GridOptions';
import { capitalize, filter, find, get, includes, isEmpty, map, orderBy, round, sum } from 'lodash';
import moment from 'moment/moment';
import { ErrorOutline } from '@mui/icons-material';

function RoomAndTime(props) {
    const [dateSelected, setDateSelected] = useState("");
    const [cartProducts, setCartPrdoucts] = useState([])
    const [cartProductSelected, setCartProductSelected] = useState(null)
    const [slotIds, setSlotIds] = useState([])
    const [timesBySlot, setTimesBySlot] = useState([])
    const [allDatesPassed, setAllDatesPassed] = useState(false);
    const [noAvailableSlots, setNoAvailableSlots] = useState(false);
    const { setDataByStep, setBookingStep, setAlert } = props;
    const { available_dates: unorderedAvailableDates, data } = get(props, "2", {})
    const available_dates = useMemo(() => {
        return orderBy(unorderedAvailableDates, (dte) => dte, ["asc"])
    }, [unorderedAvailableDates])

    const dateOptions = useMemo(() => map(available_dates, (dte, index) => {
        const mmt = moment(dte, "YYYY-MM-DD")
        return {
            index,
            title: <div className='size-16-20 mb-16'>{mmt.format("ddd")}</div>,
            body: <div className='size-16-24'>{mmt.format("D")}</div>,
            description: <div className='size-14-20'>{mmt.format("MMM")}</div>,
            date: dte,
            selected: dateSelected === dte,
        }
    }), [available_dates, dateSelected])
    const tabs = useMemo(() => map(cartProducts, (el, index) => {
        return {
            index,
            title: <div className='size-14-16 font-weight-bold'>
                {el.room_number}<br />
                {el.provider_name || "Provider TBD"}
            </div>,
            slots: el.slots,
        }
    }), [cartProducts])

    const list = useMemo(() => {
        const breaksList = filter(cartProductSelected?.slots || [], (o) => (o.is_break))
        const filteredSlots = filter(cartProductSelected?.slots || [], (o) => {
            let findBreakAtSameTime = find(breaksList, (br) => {
                return br.start_time === o.start_time && br.end_time === o.end_time
            })
            return !o.is_break && !findBreakAtSameTime
        })
        return map(filteredSlots, (el, index) => {
            return {
                index,
                id: el.id,
                date: el.date,
                title: el.start_time,
                subtitle: el.available ? "Available" : "Unavailable",
                available: el.available,
                total_amount: el.total_amount,
                selected: includes(slotIds, el.id),
                start_time: el.start_time,
                end_time: el.end_time,
            }
        })
    }, [cartProductSelected, slotIds])

    const total = useMemo(() => {
        return sum(map(list, (el) => {
            if (el.selected) {
                return Number(el.total_amount)
            }
        }))
    }, [list])

    useEffect(() => {
        if (!dateSelected && !isEmpty(available_dates) && !allDatesPassed) {
            setDateSelected(available_dates[0]);
            // TODO need to check if the first date is available
        }
        //  else if (!dateSelected) {
        //     setDateSelected(moment(new Date()).format("YYYY-MM-DD"));
        // }
    }, [available_dates, allDatesPassed])

    useEffect(() => {
        if (!isEmpty(dateOptions)) {
            const endDate = moment(dateOptions[dateOptions.length - 1].date);
            if (moment().isAfter(endDate, 'day')) {
                setAllDatesPassed(true);
            }
        }
    }, [dateOptions])

    useEffect(() => {
        setNoAvailableSlots(isEmpty(list));
    }, [list])

    useEffect(() => {
        if (dateSelected) {
            const cpHolder = find(data, (el) => el.date === dateSelected)
            if (cpHolder) {
                setCartPrdoucts(cpHolder.cart_products)
            }
        }
    }, [dateSelected])

    useEffect(() => {
        setSlotIds([])
        setTimesBySlot([])
    }, [dateSelected, cartProductSelected])

    const submitSlotsAndNext = () => {
        if (isEmpty(slotIds)) {
            setAlert("error", "Please select at least one slot");
            return;
        }

        setDataByStep(3, {
            slotIds,
            provider_name: get(cartProductSelected, "provider_name", "") || "Provider TBD",
            room_number: get(cartProductSelected, "room_number", ""),
            date: dateSelected,
            total: round(Number(total), 2).toFixed(2),
            timesBySlot: orderBy(timesBySlot, ["start_time"], ["asc"]),
            location_id: get(cartProductSelected, "location_id", ""),
            location_name: get(cartProductSelected, "location_name", ""),
            timezone: get(cartProductSelected, "timezone", ""),
        });
        setBookingStep(3);
    }
    if (allDatesPassed) {
        setAlert("error", "All available dates have passed. Please select a different location.");
        return <>
            <div className='contentPrimary font-weight-bold size-44-52 sm-size-28-36 mb-40'>
                All available dates have passed
            </div><div className='size-24-32 contentTertiary '>
                <div className='mb-16'>
                    <ErrorOutline style={{ fontSize: '42px' }} />
                </div>
                <div>
                    No available dates
                </div>
            </div>

        </>;
    }
    return (<>
        <div className='contentPrimary font-weight-bold size-44-52 sm-size-28-36 mb-16 sm-mb-8'>
            Select a room and time
        </div>
        {get(cartProducts, "0.title", "") ? <div className='size-18-24 font-weight-bold contentPrimary mb-16'>
            <div className='br-rd-4 bg-secondary p-6-12 w-m-auto'>{get(cartProducts, "0.title", "")}</div>
        </div> : null}
        {get(cartProducts, "0.sub_title", "") ? <div className='size-18-28 sm-size-16-24 contentPrimary mb-8'>
            {/* NOTE: this is dynamic, depending on the max slot selection steup in property */}
            {capitalize(get(cartProducts, "0.sub_title", ""))}
        </div> : null}
        <div className='pb-48 br-b-opaque mb-16'>
            <HorizontalList data={dateOptions} clickHandler={(el) => {
                if (el?.date && el?.available) {
                    setDateSelected(el.date)
                } else {
                    setAlert("error", "No available slots on this date");
                }
            }} />
        </div>
        <div className='mb-16 '>
            <TabsView tabs={tabs} clickHandler={(el) => {
                setCartProductSelected(cartProducts[el])
            }} />
        </div>
        {!dateSelected ? <div className='size-16-20 contentTertiary '>
            Options will show up when you select a date
        </div> : noAvailableSlots ? <div className='size-16-20 contentTertiary '>
            <div className='mb-16'>
                <ErrorOutline style={{ fontSize: '36px' }} />
            </div>
            <div>
                No available slots for this date
            </div>
        </div> : <>
        {cartProductSelected && (
            <div className='size-16-24 contentSecondary mb-16 mt-16'>
                Available time slots for <span className='font-weight-bold'>{cartProductSelected.provider_name || "Provider TBD"}</span>
            </div>
        )}
         <GridOptions list={list} clickHandler={(el) => {
            if (el.selected) {
                setSlotIds((prev) => filter(prev, (o) => o !== el.id))
                setTimesBySlot((prev) => filter(prev, (o) => o.slotId !== el.id))
            } else {
                if (slotIds?.length === get(cartProductSelected, "max_slots_per_user", 0)) {
                    setAlert("error", `You can only select ${get(cartProductSelected, "max_slots_per_user", 0)} slots`)
                    return
                }
                setSlotIds((prev) => [...prev, el.id])
                setTimesBySlot((prev) => [...prev, {
                    slotId: el.id,
                    start_time: el.start_time,
                    end_time: el.end_time,
                }])
            }
        }} />
        </>
        }

        {isEmpty(slotIds) ? null : <div className='fxd-btm'>
            <span className='mr-16'>Subtotal <span className='font-weight-bold'>${round(total, 2).toFixed(2)}</span></span>
            <button
                type="button"
                className="btn cta-primary p-16-20-imp"
                onClick={(e) => {
                    e?.preventDefault();
                    submitSlotsAndNext();
                }}>
                Continue
            </button>
        </div>}
    </>);
}
const mapStateToProps = (state) => ({
    ...state.booking
});
export default connect(mapStateToProps, {
    setBookingStep, setDataByStep, setCart
})(RoomAndTime);